import Glide from '@glidejs/glide';
import './select.js';

(function($) {
  class HeThemeApplication {
    constructor () {
      const self = this;

      $(document).ready(function() {
        self.init();
      });
    }

    init () {
      this.screenWidth = $(document).width();
      this.scrollTop = $(window).scrollTop();

      this.initContent();
      this.initMenu();
      this.initAccordion();
      this.initSlider();

      const self = this;

      this.moveHeaderInfobox();

      setTimeout(function() {
        self.moveHeaderInfobox();
      }, 500);
    }

    initContent() {
      $('figure.alignleft, figure.alignright').parent().addClass('is-aligned');
    }

    scroll() {
      this.scrollTop = $(window).scrollTop();
    }

    lateInit () {
    }

    resize () {
      this.screenWidth = $(document).width();
      this.moveHeaderInfobox();
    }

    moveHeaderInfobox() {
      const infobox = $('.headerimage__infobox');
      const immoSearch = $('.immo-search-front-page');
      const immoSearchBox = $('.immo-search-front-page > .wp-block-cover__inner-container');

      if (! infobox.length || ! immoSearch.length) {
        return;
      }

      if (window.matchMedia('(min-width: 700px)').matches) {
        infobox.css({top: ''});

        return;
      }

      const immoSearchTop = immoSearchBox.offset().top;
      const immoSearchHeight = immoSearch.outerHeight();
      const headerHeight = $('.header').outerHeight();

      const top = immoSearchTop - headerHeight - immoSearchHeight + 2;

      infobox.css({
        top: top
      });
    }

    initMenu() {
      $('.primary__link--with-children').click(event => {
        const target = $(event.target);

        if (target.width() - event.offsetX <= 20 && window.matchMedia('(max-width: 1099px)').matches) {
          event.preventDefault();

          target.toggleClass('primary__link--open');
          target.next('.primary__sub-menu').slideToggle();
        }
      });

      $('.hamburger').click(event => {
        event.preventDefault();

        $('.hamburger').toggleClass('hamburger--active');
        $('.header__menu-wrapper').toggleClass('header__menu-wrapper--active');
        $('.header').toggleClass('header--sub-menu-open');
      });
    }

    initAccordion() {
      const accordions = $('.mk-accordion');

      accordions.each((id, accordion) => {
        accordion = $(accordion);

        const content = accordion.find('.mk-accordion__content');
        const trigger = accordion.find('.mk-accordion__trigger');
        const triggerTexts = {
          closed: trigger.text(),
          open: 'zuklappen',
        };
        let state = 'closed';


        content.hide();

        trigger.click(event => {
          event.preventDefault();

          if (state == 'closed') {
            state = 'open';
          }
          else {
            state = 'closed';
          }

          trigger.text(triggerTexts[state]);

          content.slideToggle();
          trigger.toggleClass('open');
        });
      });
    }

    initSlider() {
      if (! $('.testimonials__slider').length) {
        return;
      }

      new Glide('.testimonials__slider', {
        type: 'carousel',
        autoplay: 8000,
      }).mount();
    }
  }

  const heThemeApp = new HeThemeApplication();

  $(window)
    .on('load', function() {
      heThemeApp.lateInit();
    })
    .on('scroll', function() {
      heThemeApp.scroll();
    })
    .resize(function() {
      heThemeApp.resize();
    });

})(jQuery);
